export const sortLinks = (a: any , b:any) => {
    const reA = /[^a-zA-Z]/g;
    const aA = a?.image_name?.replace(reA, "");
    const bA = b?.image_name?.replace(reA, "");
    if (aA === bA) {
        const aN = Number(a?.image_name.substring(a?.image_name.indexOf("_P") + 2, a?.image_name.lastIndexOf(".jpeg")));
        const bN = Number(b?.image_name.substring(b?.image_name.indexOf("_P") + 2, b?.image_name.lastIndexOf(".jpeg")));
        return aN === bN ? 0 : aN > bN ? 1 : -1;
    } else {
        return aA > bA ? 1 : -1;
    }
};
